// Core
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 40px;

  ::-webkit-scrollbar {
    width: 0.625rem;
    height: 0.625rem;
  };

  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 3.375rem;
    margin: 0.25rem;
  };

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.color.modalPanel.scrollBackgroundColor};
    border-radius: 3.375rem;
    border: 0.125rem solid transparent;
    background-clip: padding-box;
  };

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  };
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  width: 100%;
  gap: 16px;
  align-items: stretch;
`;
